/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GenerateUserTokenRequest } from '../../models/generate-user-token-request';
import { GenerateUserTokenResult } from '../../models/generate-user-token-result';

export interface ApiAdminGenerateUserTokenPost$Params {
      body?: GenerateUserTokenRequest
}

export function apiAdminGenerateUserTokenPost(http: HttpClient, rootUrl: string, params?: ApiAdminGenerateUserTokenPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GenerateUserTokenResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminGenerateUserTokenPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GenerateUserTokenResult>;
    })
  );
}

apiAdminGenerateUserTokenPost.PATH = '/api/Admin/generate-user-token';
